import { Center } from "../../../../Models/Center";
import { useGem } from "../../../../Utils/UseGem";

const useGetCenters = () => {
  const { res, loading } = useGem<Center[]>({ url: "Legacy/V1/Centers" });
  return { res, loading };
};

export default useGetCenters;
